// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._Dpf_SWkXH {
  padding: 4px 8px;
  height: auto;
}
._Dpf_SWkXH [data-testid="pcs-circular-spinner"] {
  width: 10px;
  height: 10px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"asset-advance__button": `_Dpf_SWkXH`
};
export default ___CSS_LOADER_EXPORT___;
